import React from "react";

import { A } from "./styled/A";

export function SupportNumber(props) {
    return (
        <A {...props} href="tel:0131 226 9535" rel="nofollow">
            0131 226 9535
        </A>
    );
}
